import { TUserRole } from '../api/user/types'

type TNamed = { agencyId: string; agencyName?: string | null; tradingAs?: string | null }

/** Support works on trading names; the entity name is only the fallback. */
export const agencyDisplayName = ({ tradingAs, agencyName, agencyId }: TNamed): string =>
  tradingAs?.trim() || agencyName?.trim() || agencyId

/** The entity name as a second line, only when the trading name is the one displayed. */
export const agencyEntityLine = ({ tradingAs, agencyName }: TNamed): string | null => {
  const trading = tradingAs?.trim()
  const entity = agencyName?.trim()
  return trading && entity && entity !== trading ? entity : null
}

const ROLE_LABELS: Record<TUserRole, string> = {
  Owner: 'Account Owner',
  TeamMember: 'Team Member',
  ReadOnlyMember: 'Read-only',
}

export const roleLabel = (role?: string | null): string => (role ? ROLE_LABELS[role as TUserRole] ?? role : '—')
